import { Avatar, Box, Image, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export const ShowTyping = ({ botDetails }) => {
  function returnRandomAIMessage() {
    const aiLoadingMessages = [
      "Analyzing your request...",
      "Fetching the best response for you...",
      "Thinking... just a moment!",
      "Processing your query...",
      "AI is on it—hang tight!",
      "Looking up the best answer for you...",
      "Generating a response...",
      "Let me find that for you...",
      "Please wait while I assist you...",
      "Finding the most relevant information...",
    ];
    let index = Math.floor(Math.random() * aiLoadingMessages.length);
    return aiLoadingMessages[index];
  }

  const [message, setMessage] = useState(returnRandomAIMessage());

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage(returnRandomAIMessage());
    }, 2800);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box>
      <Box display={"flex"} mb={"12px"} gap={"10px"}>
        <Avatar
          src={
            botDetails.companyLogo ||
            "https://e7.pngegg.com/pngimages/178/595/png-clipart-user-profile-computer-icons-login-user-avatars-monochrome-black.png"
          }
          name="Company"
          size="sm"
        />
        <Box
          fontSize={"14px"}
          bg={"#F3F4F6"}
          fontWeight={"400"}
          p={"8px"}
          borderRadius={"6px"}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={"5px"}
        >
          <Spinner
            thickness="3px"
            speed="0.8s"
            emptyColor="gray.200"
            color="gray.500"
            size="sm"
          />
        </Box>
      </Box>
      <p style={{ fontSize: "11px",color:"black" }}>{message}</p>
    </Box>
  );
};
